import { possibleIcons } from '@/ui/icons/icon/Icon'
import { z } from 'zod'
import { LoyaltyColorSchema } from './LoyaltyColor'

export const LoyaltyIconSchema = z.object({
  name: z.enum(
    Object.keys(possibleIcons) as [
      keyof typeof possibleIcons,
      ...Array<keyof typeof possibleIcons>,
    ],
  ),
  color: LoyaltyColorSchema,
})
export type LoyaltyIcon = z.infer<typeof LoyaltyIconSchema>
